import { Outlet } from "react-router-dom"

export const LayoutLogin = () => {
    return (
        <main>
            <Outlet />
        </main>
    )
}